module.exports = __webpack_public_path__ + "img/notifications-advanced-0.d21fd693.svg";